module.exports = "static/assets/d4708e8517c8e85b5c1948c845e662ba.mp3";